module.exports = __webpack_public_path__ + "static/media/kidproject.55af9dd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/kidproject.jpg
// module id = 399
// module chunks = 0